module.exports = __webpack_public_path__ + "img/location_outdoors.7c19f62c.jpg";